import { useState } from 'react'
import { useMutation, useQuery } from 'convex/react'
import { useNavigate } from 'react-router-dom'
import type { Id } from '../../../convex/_generated/dataModel'
import { api } from '@/lib/convex-api'
import { authClient } from '@/lib/auth/client'
import { errorText } from '@/lib/error-message'
import { Button } from '@/components/ui/button'

export function DisabledWorkspace() {
  const choices: { organizationId: Id<'organizations'>; name: string }[] | undefined = useQuery(api.workspace.workspaceChoices, {})
  const select = useMutation(api.workspace.setActiveWorkspace)
  const navigate = useNavigate()
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  async function switchWorkspace(organizationId: Id<'organizations'>) {
    setBusy(true)
    setError(null)
    try {
      await select({ organizationId })
      navigate('/dashboard', { replace: true })
    } catch (err) {
      setError(errorText(err))
    } finally {
      setBusy(false)
    }
  }
  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas p-6">
      <div className="panel w-full max-w-lg p-8 text-center">
        <h1 className="text-2xl font-semibold">Workspace unavailable</h1>
        <p className="mt-3 text-sm leading-6 text-ink-soft">
          This organization’s access has been disabled. Contact KindLumen support for help.
        </p>
        {choices === undefined && <p className="mt-5 text-sm text-ink-soft" role="status">Loading workspaces…</p>}
        {choices && choices.length > 0 && (
          <div className="mt-6 space-y-3">
            <h2 className="text-sm font-semibold">Switch to another workspace</h2>
            {choices.map((choice) => (
              <Button key={choice.organizationId} className="w-full" variant="secondary" disabled={busy}
                onClick={() => void switchWorkspace(choice.organizationId)}>
                {choice.name}
              </Button>
            ))}
          </div>
        )}
        {error && <p role="alert" className="mt-4 text-sm text-danger">{error}</p>}
        <Button className="mt-6" variant="ghost" disabled={busy} onClick={() => void authClient.signOut()}>Sign out</Button>
      </div>
    </div>
  )
}
